export const BRAND_NAME = "SimpleClaw";
export const PROJECT_NAME = "simpleclaw";
export const SITE_DOMAIN = "simpleclaw.org";
export const SITE_URL = "https://www.simpleclaw.org";
export const SUPPORT_EMAIL = "support@simpleclaw.org";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
